// src/pages/InsuranceScreen.js
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import getInsuranceData from "../../modals/getInsuranceData";
import Header from "../../components/Header/Header";
import Modaldata from "../../components/Modaldata/Modaldata";
import Headerpackages from "../../components/Header/Headerpackages";


const Insurancescreen = () => {
//   const session = JSON.parse(sessionStorage.getItem("user"));
//   const customerNumber = session.userMsisdn;
//   console.log(customerNumber);
  const { type, id } = useParams();

  //advisory
  const isAgronomi = type === "agronomi";
  const isCrop = type === "crop";
  const isHealthadvisory = type === "healthadvisory";
  const isLegaladvisory = type === "legaladvisory";

  
   //bundle
  const bundlelegalHealth = type === "bundlelegalHealth";
  const isBundlelivestock = type === "bundlelivestockAgri";
  const isLifelegal = type === "bundleLegallife";

   //Insurance
  const isHealthcard = type === "healthcard";
  const isHealthcardwomen = type === "healthcardwomen";
  const isHealthinsurance = type === "healthinsurance";
  const isHealthlegal = type === "healthlegal";

  const isIncomeProtection = type === "incomeprotection";
  const isRSABike = type === "rsabikeinsurance";
  const isRSACar = type === "rsacarinsurance";

  const isMobile = type === "mobile";
  const isLife = type === "life";
  const isLifestock = type === "lifestock";
  const isVeterinaryadvisory = type === "veterinaryadvisory";


  const navigate = useNavigate();
  const [details, setDetails] = useState(null);

  const items = getInsuranceData(type);


    if (isMobile) {
      return (
        <div>
          <Headerpackages title={`<span style="color:#8cc63e; font-weight:600;">Mobile</span> Insurance`} />
          <Modaldata items={items} />
        </div>
      );
    }else if (bundlelegalHealth) {
      return (
        <div>
          <Headerpackages title={`<span style="color:#8cc63e; font-weight:600;">Health Insurance,</span>Doctor & Legal Advisroy`} />
          <Modaldata items={items} />
        </div>
      );
    }else if (isBundlelivestock) {
        return (
          <div>
            <Headerpackages title={`<span style="color:#8cc63e; font-weight:600;">Livestock Insurance</span> Agri and Vet Advisory`} />
            <Modaldata items={items} />
          </div>
        );
    }else if (isLifelegal) {
      return (
        <div>
          <Headerpackages title={`<span style="color:#8cc63e; font-weight:600;">Life Insurance</span> Doctor & Legal Advisory`} />
          <Modaldata items={items} />
        </div>
      );
    }else if (isCrop) {
      return (
        <div>
          <Headerpackages title={`<span style="color:#8cc63e; font-weight:600;">Crop</span> Insurance`} />
          <Modaldata items={items} />
        </div>
      );
    }else if (isIncomeProtection) {
      return (
        <div>
          <Headerpackages title={`<span style="color:#8cc63e; font-weight:600;">Income</span> Protection`} />
          <Modaldata items={items} />
        </div>
      );
    }else if (isRSABike) {
      return (
        <div>
          <Headerpackages title={`<span style="color:#8cc63e; font-weight:600;">RSA Bike</span> Insurance`} />
          <Modaldata items={items} />
        </div>
      );
    }else if (isRSACar) {
      return (
        <div>
          <Headerpackages title={`<span style="color:#8cc63e; font-weight:600;">RSA Car</span> Insurance`} />
          <Modaldata items={items} />
        </div>
      );
    }else if (isHealthcard) {
      return (
        <div>
          <Headerpackages title={`<span style="color:#8cc63e; font-weight:600;">Health</span> Card`} />
          <Modaldata items={items} />
        </div>
      );
    }else if (isHealthcardwomen) {
      return (
        <div>
          <Headerpackages title={`<span style="color:#8cc63e; font-weight:600;">Healthcard</span> Women`} />
          <Modaldata items={items} />
        </div>
      );
    }else if (isHealthinsurance) {
      return (
        <div>
          <Headerpackages title={`<span style="color:#8cc63e; font-weight:600;">Health</span> Insurance`} />
          <Modaldata items={items} />
        </div>
      );
    }else if (isHealthlegal) {
      return (
        <div>
          <Headerpackages title={`<span style="color:#8cc63e; font-weight:600;">Health Insurance,</span> Doctor & Legal Service`} />
          <Modaldata items={items} />
        </div>
      );
    }else if (isLife) {
      return (
        <div>
          <Headerpackages title={`<span style="color:#8cc63e; font-weight:600;">Life</span> Insurance`} />
          <Modaldata items={items} />
        </div>
      );
    }else if (isLifestock) {
      return (
        <div>
          <Headerpackages title={`<span style="color:#8cc63e; font-weight:600">Lifestock</span> Insurance`} />
          <Modaldata items={items} />
        </div>
      );
    }else if (isHealthadvisory) {
      return (
        <div>
          <Headerpackages title={`<span style="color:#8cc63e; font-weight:600;">Health</span> Advisory`} />
          <Modaldata items={items} />
        </div>
      );
    }else if (isLegaladvisory) {
      return (
        <div>
          <Headerpackages title={`<span style="color:#8cc63e; font-weight:600;">Legal</span> Advisory`} />
          <Modaldata items={items} />
        </div>
      );
    }else if (isAgronomi) {
        return (
          <div>
            <Headerpackages title={`<span style="color:#8cc63e; font-weight:600;">Agro Nomi</span> Advisory`} />
            <Modaldata items={items} />
          </div>
        );
    }else {
        return (
          <div>
            <Headerpackages
              title={`<span style="color:#8cc63e; font-weight:600">Veterinary</span> Advisory`}
            />
            <Modaldata items={items} />
          </div>
        );
    }
    
  }


export default Insurancescreen;
